export default "__VITE_ASSET__DEqiHpM2__"